module.exports = __webpack_public_path__ + "img/embryology.c6d780a7.svg";